import { call, put, takeLatest } from "redux-saga/effects";
import {
  addBlockFailure,
  addBlockSuccess,
  deleteBlockFailure,
  deleteBlockSuccess,
  fetchAllBlocksFailure,
  fetchAllBlocksSuccess,
  fetchBlockFailure,
  fetchBlocksFailure,
  fetchBlocksSuccess,
  fetchBlockSuccess,
  updateBlockFailure,
  updateBlockSuccess,
  fetchCommonBlocksSuccess,
  fetchCommonBlocksFailure,
} from "./blockAction";
import {
  addBlockEffect,
  deleteBlockEffect,
  editBlockEffect,
  listAllBlockEffect,
  listBlockEffect,
  ViewBlockEffect,
  listCommonBlockEffect,
} from "./blockEffect";
import {
  ADD_BLOCK_REQUEST,
  DELETE_BLOCK_REQUEST,
  FETCH_BLOCK_REQUEST,
  FETCH_LIST_ALL_BLOCK_REQUEST,
  FETCH_LIST_BLOCK_REQUEST,
  UPDATE_BLOCK_REQUEST,
  FETCH_COMMON_BLOCK_REQUEST,
} from "./blockType";

function* fetchBlocksSaga(action) {
  try {
    const response = yield call(listBlockEffect, action.payload);
    yield put(fetchBlocksSuccess(response.data));
  } catch (error) {
    yield put(fetchBlocksFailure(error.message));
  }
}

function* fetchAllBlocksSaga(action) {
  try {
    const response = yield call(listAllBlockEffect, action.payload);
    yield put(fetchAllBlocksSuccess(response.data));
  } catch (error) {
    yield put(fetchAllBlocksFailure(error.message));
  }
}
function* fetchBlockSaga(action) {
  try {
    const response = yield call(ViewBlockEffect, action.payload.BlockId);
    yield put(fetchBlockSuccess(response.data));
  } catch (error) {
    yield put(fetchBlockFailure(error.message));
  }
}

function* addBlockSaga(action) {
  try {
    const response = yield call(addBlockEffect, action?.payload?.blockData);
    yield put(addBlockSuccess(response.data));
  } catch (error) {
    yield put(addBlockFailure(error.message));
  }
}

function* updateBlockSaga(action) {
  try {
    const response = yield call(
      editBlockEffect,
      action.payload?.blockId,
      action.payload.blockId?.id
    );
    yield put(updateBlockSuccess(response.data));
  } catch (error) {
    yield put(updateBlockFailure(error.message));
  }
}

function* deleteBlockSaga(action) {
  try {
    yield call(deleteBlockEffect, action.payload.blockId);
    yield put(deleteBlockSuccess(action.payload.BlockId));
  } catch (error) {
    yield put(deleteBlockFailure(error.message));
  }
}

function* fetchCommonBlocksSaga() {
  try {
    const response = yield call(listCommonBlockEffect);
    yield put(fetchCommonBlocksSuccess(response.data));
  } catch (error) {
    yield put(fetchCommonBlocksFailure(error.message));
  }
}

export function* BlockSagas() {
  yield takeLatest(FETCH_LIST_BLOCK_REQUEST, fetchBlocksSaga);
  yield takeLatest(FETCH_LIST_ALL_BLOCK_REQUEST, fetchAllBlocksSaga);
  yield takeLatest(FETCH_BLOCK_REQUEST, fetchBlockSaga);
  yield takeLatest(ADD_BLOCK_REQUEST, addBlockSaga);
  yield takeLatest(UPDATE_BLOCK_REQUEST, updateBlockSaga);
  yield takeLatest(DELETE_BLOCK_REQUEST, deleteBlockSaga);
  yield takeLatest(FETCH_COMMON_BLOCK_REQUEST, fetchCommonBlocksSaga);
}
